export const api_key = "CNCPaIxRn39Rlp7NlZ6y";
export const scan_sdk_api_key = "CNCPy0WuaMn4ld8g5oTl";
export const sdkWrapperURL = (url = "") =>
  // new URL(url, "https://retail-api-one-sdk-wrapper-app.carenow.healthcare");
  new URL(url, "https://retail-api-one-int-qa-wrapper-app.carenow.healthcare");
export const sdkURL = (url = "") =>
  // new URL(url, "https://sdk-one.carenow.healthcare");
  new URL(url, "https://sdk-one-uat.carenow.healthcare");
// export const flyy_partner_id = "94d1585895da21a1b1ab";

export const cndWrapperURL = (url = "") =>
  new URL(url, "https://vc.cloudcayr-qa.careplix.com");

export const cndURL = (url = "") =>
  new URL(url, "https://api-int-qa.carenowdoc.com");
